/* 郭嘉（字奉孝） */
import { defineHero, U, D } from '../define.ts';

export default defineHero({
  id: 'guojia', name: '郭嘉', sub: '字奉孝', faction: 'wei', role: '法師', weapon: 'fan',
  look: { head: 'guan', skin: '#f3dcc4', robe: true, fx: '#7fe0d8', c: { cloth: '#2f4a6a', sleeve: '#2f4a6a', fan: '#3a3a44' } },
  skills: [
    ['寒冰暴', 'thunder', '目標受到 {75/100/125/150} 傷害，周圍再受 {100/125/150/175} 冰爆傷害，並緩速 4 秒。', { x: { k: 'nuke', dmg: [75, 100, 125, 150], splash: { r: 160, dmg: [100, 125, 150, 175] }, cc: { slow: { amt: 40, dur: 4 } }, fx: 'ice' }, aim: U(400), cd: 20 }],
    ['寒冰甲', 'shield', '為一名友軍增加 {3/5/7/9} 防禦，持續 40 秒。', { x: { k: 'buff', to: 'ally', armor: [3, 5, 7, 9], dur: 40 }, aim: U(480) }],
    ['耀目法光', 'passive', '附近友軍的氣回復速度 +{75/125/225/300}%。', { pv: { aura: { r: 560, mpR: [75, 125, 225, 300] } } }],
    ['冰河爆裂破', 'crescent', '直線冰流造成 {250/400/550} 傷害並凍結 {2/2.5/3} 秒。', { x: { k: 'line', dmg: [250, 400, 550], cc: { freeze: [2, 2.5, 3] }, rad: 50, speed: 900, shape: 'ice' }, aim: D(720, 50), shout: '冰河爆裂破！', el: 'ice' }],
  ],
});
